module.exports = __webpack_public_path__ + "media/icons/transmission-2ae32fc7.svg";